{
  "navigation": {
    "dashboard": "Dashboard"
  },
  "user": {
    "notifications": "Notifications"
  },
  "nav": {
    "mainNavigation": "Main navigation",
    "toggleSidebar": "Toggle sidebar",
    "toggleSidebarHint": "Show or hide the sidebar",
    "boxes": "Boxes",
    "currencies": "Currencies",
    "treasury": "Treasury",
    "reports": "Reports & statistics",
    "sectionSettings": "Settings",
    "settings": "Settings",
    "exchangeSettings": "Exchange settings",
    "users": "Users",
    "groups": "Groups",
    "changeBranch": "Change branch",
    "systems": "Systems"
  },
  "brand": "Al-Musafer"
}
